import React, {ReactChild, ReactChildren, useEffect, useState} from "react";
import './FloatPane.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconProp} from "@fortawesome/fontawesome-svg-core";


function dragElement(containerEl: HTMLInputElement, headerEl: HTMLInputElement) {
    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    if (headerEl) {
        // if present, the header is where you move the DIV from:
        // @ts-ignore
        headerEl.onmousedown = dragMouseDown;
    } else {
        // otherwise, move the DIV from anywhere inside the DIV:
        containerEl.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e: any) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }

    function elementDrag(e: any) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;

        // set the element's new position:
        containerEl.style.top = (containerEl.offsetTop - pos2) + "px";
        containerEl.style.left = (containerEl.offsetLeft - pos1) + "px";
        containerEl.style.right = 'inherit'
        containerEl.style.bottom = 'inherit'
    }

    function closeDragElement() {
        // stop moving when mouse button is released:
        document.onmouseup = null;
        document.onmousemove = null;
    }
}

interface Props {
    visible: boolean;
    position?: 'left' | 'right' | 'bottom'
    onVisible: () => void;
    onHide: () => void;
    className?: string;
    icon: any;
    children: ReactChildren | ReactChild[] | any
}

export const FloatPane = ({className, position, icon, visible, onVisible, onHide, children}: Props) => {
    const containerRef = React.useRef<HTMLInputElement>(null);
    const headerRef = React.useRef<HTMLInputElement>(null);
    const [openIcon, setOpenIcon] = useState<IconProp>('bookmark')
    const [closeIcon, setCloseIcon] = useState<IconProp>('compass')
    useEffect(() => {
        if (containerRef.current && headerRef.current) {
            if(position === 'left'){
                setOpenIcon('arrow-left')
                setCloseIcon('arrow-right')
                containerRef.current.style.top = '8rem';
                containerRef.current.style.left = '1rem';
            }
            if(position === 'right'){
                setOpenIcon('arrow-right')
                setCloseIcon('arrow-left')
                containerRef.current.style.top = '55px';
                containerRef.current.style.right = '10px';
            }
            if(position === 'bottom'){
                setOpenIcon('arrow-down')
                setCloseIcon('arrow-up')
                containerRef.current.style.bottom = '0';
                containerRef.current.style.left = '35px';
            }
            dragElement(containerRef.current, headerRef.current);
        }
    }, [containerRef, headerRef])


    return <div ref={containerRef}
                className={("floating-container " + className) + (!visible ? ' floating-container__close' : '')}>
        <div ref={headerRef} className={"floating-header"}>{
            visible ? <div className={`floating-button __${position}`} onClick={() => {
                onHide()
            }}>
                <span><FontAwesomeIcon icon={openIcon}/></span>
            </div> : <div className={`floating-button __${position}`} onClick={() => {
                onVisible()
            }}>
                <span><FontAwesomeIcon icon={closeIcon}/></span>
            </div>
        }</div>
        {visible ? <div className={"floating-content"}>
            {children}
        </div> : <div className={"floating-content"}>
            <div className="floating-icon">
                {typeof icon === 'string' && <img src={icon} onError={({currentTarget}) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "/images/empty.png";
                }}/>}
                {typeof icon !== 'string'&& icon }
            </div>
        </div>}
    </div>
}